import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const CampaignMissing = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 129 128" fill="none" {...props}>
    <g clipPath="url(#clip0)">
      <path
        d="M116.34 71.8085C116.339 64.1681 114.629 56.6247 111.333 49.7314C108.038 42.8382 103.242 36.7697 97.2965 31.9711C91.351 27.1725 84.4069 23.7654 76.9734 21.9995C69.5398 20.2337 61.8053 20.1539 54.337 21.766C46.8686 23.378 39.8556 26.6412 33.8124 31.3161C27.7691 35.991 22.8488 41.9591 19.412 48.7829C15.9753 55.6068 14.1093 63.1132 13.9509 70.752C13.7926 78.3907 15.3458 85.9681 18.4967 92.9285H111.783C114.793 86.2946 116.347 79.0931 116.34 71.8085Z"
        fill="#F5F4F4"
      />
      <path
        d="M14.5801 92.9277H114.42"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.82007 92.9277H12.0201"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.98 92.9277H120.18"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M96.4105 104.96C96.4105 106.24 82.3305 107.392 64.8329 107.392C47.3353 107.392 33.2681 106.304 33.2681 104.96C33.2681 103.616 47.3481 102.528 64.8329 102.528C82.3177 102.528 96.4105 103.68 96.4105 104.96Z"
        fill="#F5F4F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.0833 103.5H57.25C59.7221 99.6663 61.3419 95.3466 62 90.833H68.3333C68.9986 95.3448 70.6179 99.6629 73.0833 103.5Z"
        fill="#B56DC6"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M52.5 103.5H77.8333" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.2499 90.8333H38.2499C36.5875 90.6403 35.2763 89.3291 35.0833 87.6667V49.6667C35.2763 48.0043 36.5875 46.6931 38.2499 46.5H92.0832C93.7456 46.6931 95.0569 48.0043 95.2499 49.6667V67.0833"
        fill="#E6FBFF"
      />
      <path
        d="M76.2499 90.8333H38.2499C36.5875 90.6403 35.2763 89.3291 35.0833 87.6667V49.6667C35.2763 48.0043 36.5875 46.6931 38.2499 46.5H92.0832C93.7456 46.6931 95.0569 48.0043 95.2499 49.6667V67.0833V90.8333H76.2499Z"
        fill="#E6FBFF"
      />
      <path
        d="M76.2499 90.8333H38.2499C36.5875 90.6403 35.2763 89.3291 35.0833 87.6667V49.6667C35.2763 48.0043 36.5875 46.6931 38.2499 46.5H92.0832C93.7456 46.6931 95.0569 48.0043 95.2499 49.6667V67.0833V90.8333H76.2499Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.5 63.5V59.5C73.5 59.2348 73.3946 58.9804 73.2071 58.7929C73.0196 58.6054 72.7652 58.5 72.5 58.5H62.618C62.4323 58.4999 62.2504 58.4481 62.0925 58.3504C61.9346 58.2528 61.807 58.1131 61.724 57.947L60.776 56.053C60.693 55.8869 60.5654 55.7472 60.4075 55.6496C60.2496 55.5519 60.0677 55.5001 59.882 55.5H54.5C54.2348 55.5 53.9804 55.6054 53.7929 55.7929C53.6054 55.9804 53.5 56.2348 53.5 56.5V71.5C53.5 71.7652 53.6054 72.0196 53.7929 72.2071C53.9804 72.3946 54.2348 72.5 54.5 72.5H61.5"
        fill="#FDF5FF"
      />
      <path
        d="M73.5 63.5V59.5C73.5 59.2348 73.3946 58.9804 73.2071 58.7929C73.0196 58.6054 72.7652 58.5 72.5 58.5H62.618C62.4323 58.4999 62.2504 58.4481 62.0925 58.3504C61.9346 58.2528 61.807 58.1131 61.724 57.947L60.776 56.053C60.693 55.8869 60.5654 55.7472 60.4075 55.6496C60.2496 55.5519 60.0677 55.5001 59.882 55.5H54.5C54.2348 55.5 53.9804 55.6054 53.7929 55.7929C53.6054 55.9804 53.5 56.2348 53.5 56.5V71.5C53.5 71.7652 53.6054 72.0196 53.7929 72.2071C53.9804 72.3946 54.2348 72.5 54.5 72.5H61.5"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.5 71.5C62.5 73.6217 63.3429 75.6566 64.8431 77.1569C66.3434 78.6571 68.3783 79.5 70.5 79.5C72.6217 79.5 74.6566 78.6571 76.1569 77.1569C77.6571 75.6566 78.5 73.6217 78.5 71.5C78.5 69.3783 77.6571 67.3434 76.1569 65.8431C74.6566 64.3429 72.6217 63.5 70.5 63.5C68.3783 63.5 66.3434 64.3429 64.8431 65.8431C63.3429 67.3434 62.5 69.3783 62.5 71.5Z"
        fill="#FAECAD"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68 69.5557C68 69.0612 68.1466 68.5779 68.4213 68.1667C68.696 67.7556 69.0865 67.4352 69.5433 67.246C70.0001 67.0567 70.5028 67.0072 70.9877 67.1037C71.4727 67.2002 71.9181 67.4383 72.2678 67.7879C72.6174 68.1375 72.8555 68.583 72.952 69.0679C73.0484 69.5529 72.9989 70.0556 72.8097 70.5124C72.6205 70.9692 72.3 71.3596 71.8889 71.6343C71.4778 71.909 70.9945 72.0557 70.5 72.0557V73.389"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.5001 76.0557C70.566 76.0557 70.6305 76.0752 70.6853 76.1118C70.7401 76.1485 70.7828 76.2005 70.808 76.2614C70.8333 76.3223 70.8399 76.3894 70.827 76.454C70.8141 76.5187 70.7824 76.5781 70.7358 76.6247C70.6892 76.6713 70.6298 76.7031 70.5651 76.7159C70.5005 76.7288 70.4334 76.7222 70.3725 76.697C70.3116 76.6717 70.2596 76.629 70.2229 76.5742C70.1863 76.5194 70.1667 76.4549 70.1667 76.389C70.1667 76.3006 70.2019 76.2158 70.2644 76.1533C70.3269 76.0908 70.4117 76.0557 70.5001 76.0557Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.0833 84.5H76.2499H35.0833Z"
        fill="#B56DC6"
      />
      <path
        d="M35.0833 84.5H76.2499H95.2499V89.25L93.6666 90.8333H38.2499C35.8749 90.8333 35.0833 90.8333 35.0833 88.4583V84.5Z"
        fill="#B56DC6"
      />
      <path
        d="M35.0833 84.5H76.2499H95.2499V89.25L93.6666 90.8333M35.0833 84.5C35.0833 84.5 35.0833 86.0833 35.0833 88.4583M35.0833 84.5V88.4583M93.6666 90.8333C93.6666 90.8333 40.6249 90.8333 38.2499 90.8333M93.6666 90.8333H38.2499M38.2499 90.8333C35.8749 90.8333 35.0833 90.8333 35.0833 88.4583"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.0833 103.5C86.9469 103.5 82.5833 100.72 82.5833 95.5837V87.667H101.583V95.5837C101.45 97.9236 100.352 100.103 98.5514 101.604C96.7509 103.104 94.4089 103.791 92.0833 103.5Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89.4265 77.375C87.1085 79.693 91.7255 80.4815 89.4581 82.7583"
        stroke="#CCC8CA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M98.2188 78.5625C96.4375 79.75 99.4063 80.9375 97.8767 82.7188"
        stroke="#CCC8CA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.7298 73.3301C89.6955 77.3644 97.7357 78.7387 93.7868 82.6876"
        stroke="#CCC8CA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M101.583 89.25H103.166C105.79 89.25 107.916 91.3766 107.916 94C107.916 96.6234 105.79 98.75 103.166 98.75H100.779"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="128" height="128" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </SvgIcon>
);
